export default {
    'home title': 'Stake FIL',
    'home tips': '质押FIL或接收stFIL。',
    'home': '首页',
    'faq': '问题',
    'max': '最大',
    'you-will-receive': '您将收到',
    'exchange-rate': '汇率',
    'transaction-cost': '交易成本',
    'reward-fee': '奖励费',
    'reward-fee-tip': '建立在 Filecoin 之上的流动性权益协议允许用户在不锁定资产或维护存储提供商基础设施的情况下获得大笔奖励。',
    'unstake-tip-befor': '默认的 stFIL 取消质押期需要大约 3-4 天（80 个纪元）来处理。之后，您可以在',
    'unstake-tip-after': '选项卡中领取您的奖励',
    'claim-tip-befor': '处理提款请求后，您将能够领取奖励。要取消质押您的金额，请转到',
    'claim-tip-after': '选项卡',
    'connect-wallet': '连接钱包',
    'statistics': '统计数据',
    'annual-percentage-rate': '年利率',
    'total-staked-with': '与 STFIL 的总质押',
    'stakers': '质押数',
    'market-cap': 'stFIL 市值',
    'total-claimable-rewards': '总可领取奖励',
    'pending-amount': '待定金额',
    'faq_1': "最低存款是多少？",
    'faq_1_content': "STFIL 协议允许任何人通过低至 0.1 FIL 的存款获得奖励。允许持有者（Asset）将他们的 FIL资产存入流动质押的智能合约，来铸造 1 比 1 的 质押代币stFIL，并且不用被锁定在我们这里，无论在何处获得，stFIL 都会累积质押奖励。",
    'faq_2': "最高存款是多少？",
    'faq_2_content': "随心所欲，无限制。",
    'faq_3': "什么是 Liquid Staking？",
    'faq_3_content': "流动性质押协议允许用户在不锁定资产或维护质押基础设施的情况下获得质押奖励。这些协议的用户可以存入质押代币并获得可交易的流动性代币作为回报。DAO 控制的智能合约然后与 DAO 挑选的存储提供商（SP）进行代币质押。用户存入的资金由 DAO 控制，存储提供商永远无法直接访问用户的资产。",
    'faq_4': "我该如何解除质押？",
    'faq_4_content': "STFIL 协议始终保持stFIL和FIL是1比1的关系，金库将设置存款准备金，只要协议中有可用的流动性来覆盖交换，您就可以将它们交易回协议以获得FIL。",
    'faq_5': "质押APR如何计算？",
    'faq_5_content': "APR 以 stFIL 而非美元计价，并且不是保证或承诺的回报或利润。STFIL 协议将用户质押的资金提供给精心挑选的存储提供商进行代币质押，获得的收益重新铸造stFIL并分给用户，用户可以在存款后的 24 小时内收到质押奖励，而无需等待验证器激活。给用户呈现的是最近7天的平均年化收益。",
}
